import { Component, Inject, Injector } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { VIRTUAL_CARD_STATUS_ENUMERATION } from '@home/header/configs';
import { HeaderService } from '../../header.service';

export interface LockCardDialogDataType {
  cardId: string;
}

@Component({
  selector: 'app-lock-card-dialog',
  templateUrl: './lock-card-dialog.component.html',
  styleUrls: ['./lock-card-dialog.component.scss'],
})
export class LockCardDialogComponent {
  private readonly dialogRef: MatDialogRef<LockCardDialogComponent>;
  @Inject(MAT_DIALOG_DATA) private readonly data: LockCardDialogDataType;
  private readonly headerService: HeaderService;
  public isLoading: boolean;
  private readonly unSubscribe$: Subject<void>;

  constructor(private readonly injector: Injector) {
    this.dialogRef = this.injector.get(MatDialogRef);
    this.headerService = this.injector.get(HeaderService);
    this.data = this.injector.get(MAT_DIALOG_DATA);
    this.isLoading = false;
    this.unSubscribe$ = new Subject<void>();
  }

  public confirm(): void {
    this.isLoading = true;

    this.headerService
      .updateCardStatus(this.data.cardId, VIRTUAL_CARD_STATUS_ENUMERATION.BLOCKED)
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe({
        next: () => {
          this.isLoading = false;
          this.dialogRef.close({ confirmed: true });
        },
        error: () => {
          this.isLoading = false;
          this.dialogRef.close({ confirmed: false });
        },
      });
  }

  public cancel(): void {
    this.dialogRef.close({ confirmed: false });
  }
}
